import React, {Component} from 'react';

// import Joi from 'joi-browser';
import {Redirect, Link} from 'react-router-dom';
import toastr from 'toastr';
import {getCurrentUserId, getJwt, login, setCurrentUserName} from '../../services/authService';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import http from '../../services/httpService';
import Form from '../common/Form';
import Header from './Header';

class ResetPassword extends Form {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            teams: {},
            remember_me: true,
            done: false,
            spinnerActive: false,
            data: {
                password: "",
                password_confirmation: ""
            },
            errors: {}
        };
    }


    // schema = {
    //     password: Joi.string().required().label('This field'),
    //     password_confirmation: Joi.string().valid(Joi.ref('password')).required().label('This field').options({language: {any: {allowOnly: 'must match password'}}})
    // };

    doSubmit = () => {
        this.props.history.push('/password-updated');

    }

    render() {

        return (
            <div className='onboarding-container'>
                {/*<Header linkDisabled={true}/>*/}
                {/*<div className="onboarding-content reset-pass-container">*/}
                {/*    <div className="onboarding-panel">*/}
                {/*        <h1 className='onboarding-title'>Reset password</h1>*/}
                {/*        <form onSubmit={this.handleFormSubmit}>*/}
                {/*            <p className='m-sm-b'>*/}
                {/*                Choose new password*/}
                {/*            </p>*/}
                {/*            {this.renderInput("password", 'password', "********")}*/}

                {/*            <p className='m-sm-b'>*/}
                {/*                Repeat new password*/}
                {/*            </p>*/}

                {/*            {this.renderInput("password_confirmation", 'password', '********')}*/}

                {/*            {!this.state.spinnerActive ?*/}
                {/*                this.renderButton("Confirm")*/}
                {/*                :*/}
                {/*                this.renderButtonSpinner("Confirm")*/}
                {/*            }*/}
                {/*        </form>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        )
    }

}

export default ResetPassword